import { RootState, useAppSelector } from '../../store/store';
import '../../App.css';
import MainLayout from '../layout/MainLayout';
import { AppRoutes } from '../../axios/endPoints';
import { Navigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function ProtectedRouting({ children, roles }: { children: React.ReactElement, roles?: string[] }) {
    const { t } = useTranslation();
    const { user } = useAppSelector((state: RootState) => state.auth);

    if (user.email === null) 
    {
        return <Navigate to={AppRoutes.LOG_IN}/>
    }

    if(roles && !roles.includes(user.role))
    {
        return <MainLayout>
            <Card style={{ marginTop: '15px' }}>
                <CardHeader></CardHeader>
                <CardContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '40px' }}>
                    <Typography style={{ color: 'gray' }} variant='h5'>{t('translations:NOT_AUTHORIZED')}</Typography>
                </CardContent>
            </Card>
        </MainLayout>
    }

    return (
        <MainLayout>{children}</MainLayout>
    );
}